import { createFileRoute } from '@tanstack/react-router'

import { MassCallDetectionsPage } from '#/modules/communication/mass-call-detections-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/mass-call-detections')({
  component: MassCallDetectionsPage,
  validateSearch: validateListSearch,
})
